const FOLDER_TREE_INHERIT_KEYS = [
    "ignoreChildNodes",
    "rootId",
    "allowMultiSelect",
    "headline",
    "creatable",
    "toolbar",
    "multiToolbar",
    "isBusyHeader",
    "noFoldersTitle",
    "noFoldersDescription",
    "noSearchResult",
    "searchable",
    "searchInputBusy",
    "autoFocusSearchInput",
    "staticTree",
    "tree",
    "toggleExpandAll",
    "renameSaveText",
    "renameAddText"
];
const FOLDER_TREE_TOOLBAR_INITIAL_STATE = (initialToolbarActiveButton)=>({
        isToolbarActive: true,
        isToolbarBusy: false,
        isSortableDisabled: true,
        isSortableBusy: false,
        isCreatableLinkDisabled: false,
        isCreatableLinkCancel: false,
        isTreeLinkDisabled: false,
        isTreeBusy: false,
        toolbarActiveButton: initialToolbarActiveButton
    });
const FOLDER_TREE_DATA_DEFAULTS = {
    ignoreChildNodes: false,
    rootId: 0,
    allowMultiSelect: false,
    creatableParentId: 0,
    creatable: {
        buttons: {},
        backButton: {
            label: "Cancel"
        }
    },
    toolbar: {
        buttons: {},
        backButton: {
            label: "Cancel",
            save: "Done"
        }
    },
    multiToolbar: {
        buttons: {},
        backButton: {
            label: "Cancel"
        }
    },
    isBusyHeader: false,
    noFoldersTitle: "",
    noFoldersDescription: "",
    noSearchResult: "",
    searchable: true,
    searchInputBusy: false,
    autoFocusSearchInput: false,
    staticTree: [],
    tree: [],
    toggleExpandAll: true,
    renameSaveText: "Save",
    renameAddText: "Add"
};
const FOLDER_TREE_TOOLBAR_OBSERVE_KEYS = [
    "isToolbarActive",
    "isToolbarBusy",
    "isSortableDisabled",
    "isSortableBusy",
    "isCreatableLinkDisabled",
    "isCreatableLinkCancel",
    "isTreeLinkDisabled",
    "isTreeBusy",
    "toolbarActiveButton"
];
const FOLDER_TREE_UI_BUNDLE_INHERIT_KEYS = [
    "headline",
    "creatable",
    "toolbar",
    "multiToolbar",
    "isBusyHeader",
    "noFoldersTitle",
    "noFoldersDescription",
    "noSearchResult",
    "renameSaveText",
    "renameAddText"
];
export { FOLDER_TREE_DATA_DEFAULTS, FOLDER_TREE_INHERIT_KEYS, FOLDER_TREE_TOOLBAR_INITIAL_STATE, FOLDER_TREE_TOOLBAR_OBSERVE_KEYS, FOLDER_TREE_UI_BUNDLE_INHERIT_KEYS };
